import React from 'react';
import { SectionWrapper } from './SectionWrapper';
import { CTAButton } from './CTAButton';
import { Lock } from 'lucide-react';
export const OfferSection = () => {
  return <SectionWrapper id="oferta" bg="bg-navy-900" className="pb-24" data-id="element-85">
      <div className="max-w-4xl mx-auto bg-gradient-to-b from-navy-800 to-navy-900 rounded-3xl p-8 md:p-12 border-2 border-gold-500/30 shadow-[0_0_50px_rgba(201,168,76,0.1)] text-center relative overflow-hidden" data-id="element-86">
        {/* Decorative elements */}
        <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-gold-500 to-transparent" data-id="element-87"></div>

        <h2 className="font-serif text-3xl md:text-4xl font-bold text-white mb-6" data-id="element-88">
          Toma el control total hoy por una fracción del costo.
        </h2>

        <p className="text-xl text-gray-300 mb-10" data-id="element-89">
          No pagues una suscripción mensual de reparación de crédito.
        </p>

        <div className="bg-navy-900/80 inline-block px-12 py-8 rounded-2xl border border-navy-800 mb-10 shadow-inner" data-id="element-90">
          <p className="text-gray-400 uppercase tracking-widest text-sm font-bold mb-2" data-id="element-91">
            Inversión Única
          </p>
          <div className="flex items-center justify-center gap-4 mb-2" data-id="element-92">
            <span className="text-2xl text-gray-500 line-through decoration-red-500/50 decoration-2" data-id="element-93">
              $297.00
            </span>
            <span className="text-5xl md:text-6xl font-black text-gold-500" data-id="element-94">
              $37.00
            </span>
            <span className="text-xl text-gold-500 font-bold self-end mb-2" data-id="element-95">
              USD
            </span>
          </div>
          <p className="text-gray-400 italic mt-4 max-w-sm mx-auto" data-id="element-96">
            (Menos de lo que cuesta una cena afuera, pero con el poder de
            ahorrarte miles en intereses).
          </p>
        </div>

        <div className="flex flex-col items-center" data-id="element-97">
          <CTAButton onClick={() => window.open('https://webdealzshoppersave.com/cart/48207177646336:1', '_blank')} className="w-full md:w-auto md:px-12 md:py-6 text-xl md:text-2xl mb-6 shadow-[0_0_40px_rgba(201,168,76,0.4)]" data-id="element-98" />

          <div className="flex items-center gap-2 text-gray-400 text-sm" data-id="element-99">
            <Lock className="w-4 h-4" data-id="element-100" />
            <span data-id="element-101">Pago 100% seguro. Acceso inmediato tras la compra.</span>
          </div>
        </div>
      </div>
    </SectionWrapper>;
};